export default __webpack_public_path__ + "static/media/IMG_5588.804f54b5.jpg";